/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  NavLink,
} from 'react-router-dom';
import Helmet from "react-helmet"

import './styles/contacts.scss';
import './styles/main.scss';
import './styles/print.scss';
import './styles/main-header.scss';
import './styles/cv.scss';
import './styles/about.scss';

import Blog from './Blog.js';
import AnimationWork from './AnimationWork.js';
import WatermelonLoverAnimation from './projects/WatermelonLoverAnimation.js';
import AllWorks from './AllWorks.js';
import StickerPacks from './projects/StickerPacks.js';
import CV from './CV.js';
import UsualStickerPack from './projects/UsualStickerPack.js'
import CuteGirlStickerPack from './projects/CuteGirlStickerPack.js'
import AnimationTestWork from './AnimationTestWork.js'
// import ContactPage from './ContactPage.js'
import About from './About.js'
import ContactInfo from './ContactInfo.js'
import IntroText from './IntroText.js'
import Page404 from './Page404';


const activeStyle = {
  color: "#8C8989"
};
function App() {
  return (
    <Router>
      <div className="App">
        <Helmet>
          <title>Maryna Yanul</title>
          <meta name="description" content="Maryna Yanul Portfolio" />
          <meta name="og:description" content="Portfolio of 3d illustration artist Maryna Yanul" />
          <meta
            name="keywords"
            content="Marina Yanul, Content Creator, 3D, illustrator, sticker pack, marina.yanul, maryna.yanul, Марина Януль, Maryna Yanul, 3d illustrator, ukrainian, ukrainian illustrator, 3d designer, motion designer, motion ukraine, 3d character, character animation, illustrator, ілюстратор, аніматор україна, 3d художник, 3d художник україна, 3d художник київ, 3d художник киев, 3d художник украина, 3d художник украин�, 3d львів"
          />
        </Helmet>

        <header className="header">
          <div className="header-text">
            <Link to="/" className="hide-link-style">
              <h1 className="name">Maryna Yanul</h1>
            </Link>
            <p className="name-description">3d illustrator</p>

          </div>

          <div className="menu">
            <ul className="nav-links">
              <li><NavLink exact to="/" activeStyle={activeStyle} className="hide-link-style">All works</NavLink></li>
              {/*<li><NavLink exact to="/animation-work" activeStyle={activeStyle} className="hide-link-style">Animation</NavLink></li>*/}
              <li><NavLink to="/about" activeStyle={activeStyle} className="hide-link-style">About</NavLink></li>
            </ul>

            <ul className="media">
              <li>
                <a className="hide-link-style" href="https://www.instagram.com/maryna.yanul/" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="25px" height="25px"><path d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z"/></svg>
                </a>
              </li>
              <li>
                <a className="hide-link-style" href="https://dribbble.com/maryna_yanul" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="25px" height="25px"><path d="M 32 3 C 17.213129 3 4.9723492 14.146193 3.2226562 28.470703 A 1.0001 1.0001 0 0 0 3.1660156 28.923828 C 3.0586824 29.935305 3 30.960685 3 32 C 3 47.982314 16.017686 61 32 61 C 47.982314 61 61 47.982314 61 32 C 61 16.017686 47.982314 3 32 3 z M 32 5 C 46.897686 5 59 17.102314 59 32 C 59 33.01521 58.939534 34.015651 58.830078 35.001953 C 53.266771 33.448082 48.24136 32.87923 43.746094 33.035156 C 42.029497 33.094699 40.393403 33.262662 38.828125 33.513672 C 37.865919 31.031829 36.77865 28.471182 35.542969 25.886719 C 39.110523 24.552581 42.554894 22.808566 45.601562 20.515625 A 1.0001 1.0001 0 0 0 45.021484 18.708984 A 1.0001 1.0001 0 0 0 44.398438 18.917969 C 41.488331 21.108132 38.135786 22.772875 34.636719 24.044922 C 31.59279 18.000158 27.744284 11.926403 22.916016 6.5761719 C 25.756204 5.5594508 28.812786 5 32 5 z M 20.939453 7.375 C 25.778312 12.612461 29.642095 18.661881 32.699219 24.710938 C 21.187403 28.380036 8.887577 28.074334 5.3125 27.884766 C 6.7178685 18.716476 12.748543 11.065245 20.939453 7.375 z M 49.501953 14.445312 A 1.0001 1.0001 0 0 0 48.740234 14.806641 C 48.269314 15.357676 47.791123 15.888453 47.294922 16.380859 A 1.0005896 1.0005896 0 0 0 48.705078 17.800781 C 49.254877 17.255187 49.766686 16.684386 50.259766 16.107422 A 1.0001 1.0001 0 0 0 49.501953 14.445312 z M 33.613281 26.568359 C 34.80496 29.054845 35.853208 31.519292 36.791016 33.917969 C 31.975492 34.966188 27.910288 36.825159 24.59375 39.007812 C 18.126614 43.263914 14.436172 48.57868 12.925781 51.095703 C 8.0316686 46.207062 5 39.454311 5 32 C 5 31.286078 5.0352823 30.580918 5.0898438 29.880859 C 8.6534784 30.101095 21.456042 30.577217 33.613281 26.568359 z M 44.410156 34.996094 C 44.979631 34.98547 45.558339 34.987581 46.146484 35.001953 C 49.886031 35.093336 54.012496 35.717281 58.529297 37 C 57.025467 45.008702 51.982408 51.774406 45.085938 55.609375 C 44.567073 52.623363 43.010694 44.861472 39.529297 35.400391 C 41.076468 35.169656 42.701731 35.027965 44.410156 34.996094 z M 37.490234 35.763672 C 41.294823 46.003086 42.846063 54.325329 43.216797 56.554688 C 39.798648 58.12097 36.002021 59 32 59 C 25.289015 59 19.151502 56.537515 14.425781 52.476562 C 15.685263 50.31574 19.277079 44.900367 25.693359 40.677734 C 28.898261 38.56855 32.800095 36.745932 37.490234 35.763672 z M 11.335938 38.519531 A 1.0001 1.0001 0 0 0 10.974609 38.583984 L 9.09375 39.267578 A 1.0006167 1.0006167 0 1 0 9.7773438 41.148438 L 11.658203 40.462891 A 1.0001 1.0001 0 0 0 11.335938 38.519531 z M 13.529297 42.974609 A 1.0001 1.0001 0 0 0 12.994141 43.142578 L 11.316406 44.232422 A 1.0003189 1.0003189 0 1 0 12.40625 45.910156 L 14.082031 44.820312 A 1.0001 1.0001 0 0 0 13.529297 42.974609 z M 20.691406 49.845703 A 1.0001 1.0001 0 0 0 19.800781 50.341797 L 18.771484 52.056641 A 1.0001 1.0001 0 1 0 20.484375 53.085938 L 21.515625 51.371094 A 1.0001 1.0001 0 0 0 20.691406 49.845703 z M 25.195312 51.910156 A 1.0001 1.0001 0 0 0 24.240234 52.613281 L 23.621094 54.515625 A 1.000281 1.000281 0 1 0 25.523438 55.134766 L 26.142578 53.232422 A 1.0001 1.0001 0 0 0 25.195312 51.910156 z M 30.044922 52.902344 A 1.0001 1.0001 0 0 0 29.076172 53.828125 L 28.900391 55.820312 A 1.0001 1.0001 0 1 0 30.892578 55.996094 L 31.068359 54.003906 A 1.0001 1.0001 0 0 0 30.044922 52.902344 z"/></svg>
                </a>
              </li>
            </ul>
          </div>
        </header>
        <section className="main-block">
          <div className="about-text">
            <Switch>
              <Route path="/cv">
                <div className="avatar" />
              </Route>
              <Route exact path="/">
                <div className="avatar" />
              </Route>
              <Route exact path="/projector-motion-design-admission-work">
                <div className="avatar" />
              </Route>
              <Route exact path="/watermelon-lover-animation">
                <div className="avatar" />
              </Route>
              <Route exact path="/sticker-packs">
                <div className="avatar" />
              </Route>
              <Route exact path="/usual-sticker-pack">
                <div className="avatar" />
              </Route>
              <Route exact path="/cute-girl-sticker-pack">
                <div className="avatar" />
              </Route>
            </Switch>
            <Switch>
              <Route path="/cv">
                <button className="cv-button button" onClick={() => window.print()}>Print or Save my CV</button>
              </Route>
              <Route exact path="/">
                <IntroText />
              </Route>
              <Route exact path="/projector-motion-design-admission-work">
                <IntroText />
              </Route>
              <Route exact path="/watermelon-lover-animation">
                <IntroText />
              </Route>
              {/*<Route exact path="/animation-work">*/}
              {/*  <IntroText />*/}
              {/*</Route>*/}
              <Route exact path="/sticker-packs">
                <IntroText />
              </Route>
              <Route exact path="/usual-sticker-pack">
                <IntroText />
              </Route>
              <Route exact path="/cute-girl-sticker-pack">
                <IntroText />
              </Route>
            </Switch>

            </div>

          <div className="content" id="content">
            <Switch>
              <Route exact path="/">
                <AllWorks />
              </Route>
              <Route path="/blog">
                <Blog />
              </Route>
              {/*<Route path="/animation-work">*/}
              {/*  <AnimationWork />*/}
              {/*</Route>*/}
              <Route path="/sticker-packs">
                <StickerPacks />
              </Route>
              <Route path="/cv">
                <CV />
              </Route>
              <Route path="/about">
                <About />
              </Route>
              <Route exact path="/usual-sticker-pack">
                <UsualStickerPack />
              </Route>
              <Route exact path="/cute-girl-sticker-pack">
                <CuteGirlStickerPack />
              </Route>
              <Route exact path="/projector-motion-design-admission-work">
                <AnimationTestWork />
              </Route>
              <Route exact path="/watermelon-lover-animation">
                <WatermelonLoverAnimation />
              </Route>
              <Route path="*">
                <Page404 />
              </Route>
            </Switch>
          </div>
        </section>

        <Switch>
          <Route path="/cv">
            <ContactInfo />
          </Route>
          <Route exact path="/">
            <ContactInfo />
          </Route>
          {/*<Route exact path="/animation-work">*/}
          {/*  <ContactInfo />*/}
          {/*</Route>*/}
          <Route exact path="/sticker-packs">
            <ContactInfo />
          </Route>
          <Route exact path="/usual-sticker-pack">
            <ContactInfo />
          </Route>
          <Route exact path="/cute-girl-sticker-pack">
            <ContactInfo />
          </Route>
          <Route exact path="/projector-motion-design-admission-work">
            <ContactInfo />
          </Route>
          <Route exact path="/watermelon-lover-animation">
            <ContactInfo />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
